import { useGlobalStore } from "./store";
import type { AgentChatSettings, UserPreferences } from "./types";
import { queryClient } from "@app/config/api/api";
import type { CurrentUser, ExperimentId, ExperimentStatus, Team } from "@globals";
import type { DeepPartial } from "@lib/utils/DeepPartial";
import { deepMerge } from "@mantine/core";

export const updateUser = (user: CurrentUser | null) => {
  useGlobalStore.setState(() => ({
    user
  }));
};

export const updateSelectedTeam = async (team: Team | null) => {
  useGlobalStore.setState(() => ({
    selectedTeam: team
  }));

  // Invalidate all queries to refresh data for the new team context.
  await queryClient.invalidateQueries();
};
export const updateExperimentStatus = (experimentId: ExperimentId, status: ExperimentStatus) => {
  useGlobalStore.setState(state => ({
    experimentStatus: new Map(state.experimentStatus).set(experimentId, status)
  }));
};

export const updateUserPreferences = (preferences: DeepPartial<UserPreferences>) => {
  useGlobalStore.setState(state => ({
    userPreferences: deepMerge(state.userPreferences, preferences)
  }));
};

export const dismissCortexWarnings = (ids: string[]) => {
  useGlobalStore.setState(state => ({
    dismissedCortexWarningIds: [...new Set([...state.dismissedCortexWarningIds, ...ids])]
  }));
};

export const updateAgentChatSettings = (settings: Partial<AgentChatSettings>) => {
  useGlobalStore.setState(state => ({
    agentChatSettings: deepMerge(state.agentChatSettings, settings)
  }));
};
